import CryptoJS from 'crypto-js';

/** Used for creating a Google password */
export default function getPasswordHash(email) {
    const hash = CryptoJS.SHA1(email + process.env.REACT_APP_GOOGLE_SECRET).toString();
    return hash;
}